// extracted by mini-css-extract-plugin
export default {"modal":"ImageModal_modal__Lj7ma","overlay":"ImageModal_overlay__yca-V","image":"ImageModal_image__obsX3","closeButton":"ImageModal_closeButton__QyF0U"};